<template>
    <div class="materialDetails">
        <!--        下载所有材料-->
        <div class="downloadBox">
            <el-button @click="downloadBtn">下载所有材料</el-button>
        </div>
        <div class="title">
            <p></p>
            <h4>保险文书列表</h4>
        </div>
        <avue-crud :data="data" :option="option" ></avue-crud>

        <div class="title">
            <p></p>
            <h4>线索材料列表</h4>
        </div>
        <avue-crud :data="clueData" :option="option1" ></avue-crud>

        <div class="title">
            <p></p>
            <h4>保全法院的信息列表</h4>
        </div>
        <avue-crud :data="courtData" :option="option2" ></avue-crud>
    </div>
</template>

<script>
    import { downloadMaterialsFile, insuranceMaterials } from '../../../api/arbitrationCase';

    export default {
        name: 'insuranceFile',
        data() {
            return {
                data: [],  //保险文书列表
                clueData:[], //线索材料列表
                courtData:[], //法院保全材料
                option:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menu:false,
                    column:[
                        {
                            label:'文件名称',
                            prop:'name'
                        }, {
                            label:'是否需要盖章',
                            prop:'is_need_sign_txt'
                        }, {
                            label:'是否已签章',
                            prop:'is_sign_txt'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        },
                    ]
                },
                option1:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menu:false,
                    column:[
                        {
                            label:'文件名称',
                            prop:'name'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        },
                    ]
                },
                option2:{
                    stripe:true,
                    addBtn:false,  //新增按钮
                    align:'center',  //文本居中
                    menuAlign:'center', //操作栏居中
                    columnBtn:false,  //列动态显隐按钮
                    refreshBtn:false,  //刷新按钮
                    editBtn:false,  //编辑按钮
                    delBtn:false,  //删除按钮
                    menu:false,
                    column:[
                        {
                            label:'文件名称',
                            prop:'name'
                        }, {
                            label:'创建时间',
                            prop:'add_time'
                        },
                    ]
                },
            };
        },
        methods:{
            downloadBtn(){
                downloadMaterialsFile(this.$route.query.id).then(res=>{
                    if (res.code==200){
                        if (res.code==200){
                            const link = document.createElement("a"); //自己创建的a标签
                            link.href = res.data.download_url;
                            document.body.appendChild(link);
                            link.click();
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(res.data.download_url);
                            this.$message.success(res.msg);
                        }else {
                            this.$message.error(res.msg);
                        }
                    }else {
                        this.$message.error(res.msg)
                    }
                })
            }
        },
        created() {
            insuranceMaterials(this.$route.query.id).then(res=>{
                if (res.code==200){
                    this.data=res.data.baoxian_wenshu
                    this.clueData=res.data.xiansuo_cailiao
                    this.courtData=res.data.baoquan_fayuan
                }else {
                    this.$message.error(res.msg)
                }
            })
        }
    };
</script>

<style scoped>
    .materialDetails{
        padding: 30px;
        background-color: #ffffff;
        border-radius: 5px;
    }
    .title{
        color: #3e62f6;
        display: flex;
        align-items: center;
    }
    .title>p{
        margin-right: 10px;
        width: 5px;
        height: 15px;
        background-color: #3e62f6;
    }
    /deep/.avue-crud{
        margin-bottom: 50px;
    }
    .downloadBox{
        margin: 20px 0px;
    }
    .downloadBox>button{
        background-color: #3e62f6;
        color: #ffffff;
    }
</style>
